<script lang="ts">
	import Button, { Label } from '@smui/button';
	import Card, { Actions } from '@smui/card';
	import Checkbox from '@smui/checkbox';
	import FormField from '@smui/form-field';
	import Input from '@smui/textfield';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import NewsMessage from '../../../../shared/models/News/NewsMessage';

	export let data: NewsMessage = new NewsMessage();

	function setNewsAsRead() {
		let [dataNewsRead, loadingNewsRead, errorNewsRead] = NewsMessage.setNewsAsRead(data.id);
		dataNewsRead.subscribe((value) => {
			if (value == true) {
				data.attribute.isRead = true;
			}
		});
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="News" />
	</div>
	<div class="md:grid-cols-2 md:gap-x-8 md:px-4 grid grid-cols-1 pt-4">
		<FormField>
			<Checkbox disabled bind:checked="{data.isEnabled}" />
			<span slot="label">Attiva</span>
		</FormField>
		<Input disabled label="Reporter" bind:value="{data.reporter}" />
		<Input disabled label="Validità da" bind:value="{data.validFrom}" type="datetime-local" />
		<Input disabled label="Validità a" bind:value="{data.validTo}" type="datetime-local" />
		<Input disabled label="Titolo" bind:value="{data.title}" />
		<Input disabled label="Sottotitolo" bind:value="{data.subTitle}" />
	</div>
	<div class="p-4 border">
		{@html data.body}
	</div>
	{#if data.attribute?.isRead == false}
		<Actions class="justify-end pt-4">
			<Button on:click="{setNewsAsRead}" variant="raised" class="w-[250px]">
				<Label>Imposta come "letta"</Label>
			</Button>
		</Actions>
	{/if}
</Card>
